var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"page-header"},[_c('v-row',[_c('v-col',[_c('ul',_vm._l((_vm.breadcrumbList),function(breadcrumb,idx){return _c('li',{key:idx,class:{ linked: !!breadcrumb.link },on:{"click":function($event){return _vm.routeTo(idx)}}},[_vm._v(" "+_vm._s(_vm.$t(breadcrumb.name, { value: "default" }))+" ")])}),0)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }